import { createContext } from 'react';

export const CleanupContext = createContext({});